import React, { Component } from 'react';
import { View, Animated, TouchableWithoutFeedback, TouchableOpacity } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import PropTypes from 'prop-types';

import { Icon } from '@vfgroup-oneplatform/foundation/Components';
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { Images } from '../../Themes';

import ControlBar from './ControlBar';
import styles from './Video.Styles';

class Controls extends Component {
  constructor() {
    super();
    this.state = {
      hideControls: false,
      seconds: 0,
      seeking: false,
    };
    this.animControls = new Animated.Value(1);
  }

  onSeek = pos => {
    this.props.onSeek(pos);
    if (!this.state.seeking) {
      this.setState({ seeking: true });
    }
  };

  onSeekRelease = pos => {
    this.props.onSeekRelease(pos);
    this.setState({ seeking: false, seconds: 0 });
  };

  hideControls = () => {
    if (this.state.hideControls) {
      this.setState({ hideControls: false }, () => {
        Animated.timing(this.animControls, {
          toValue: 1,
          duration: 200,
          useNativeDriver: false,
        }).start();
      });
    } else {
      Animated.timing(this.animControls, {
        toValue: 0,
        duration: 200,
        useNativeDriver: false,
      }).start(({ finished }) => finished && this.setState({ hideControls: true, seconds: 0 }));
    }
  };

  render() {
    const {
      paused,
      muted,
      progress,
      currentTime,
      duration,
      toggleFS,
      toggleMute,
      togglePlay,
      onSeekRelease,
      onSeek,
      isRotated,
    } = this.props;
    return (
      <TouchableWithoutFeedback onPress={this.hideControls}>
        <Animated.View
          style={[
            styles.controlsContainer,
            { opacity: this.animControls },
            isRotated && styles.controlsContainerLandscape,
          ]}
        >
          <LinearGradient
            colors={[Colors.blackRGBA(0.7), Colors.blackRGBA(0.4), Colors.transparent]}
          >
            <View style={styles.fullScreenButtonContainer}>
              <TouchableOpacity onPress={toggleFS}>
                <Icon name={Images.minimize} type="image" />
              </TouchableOpacity>
            </View>
          </LinearGradient>
          <ControlBar
            toggleMute={toggleMute}
            togglePlay={togglePlay}
            muted={muted}
            paused={paused}
            onSeek={onSeek}
            onSeekRelease={onSeekRelease}
            progress={progress}
            currentTime={currentTime}
            duration={duration}
          />
        </Animated.View>
      </TouchableWithoutFeedback>
    );
  }
}

Controls.propTypes = {
  toggleFS: PropTypes.func.isRequired,
  toggleMute: PropTypes.func.isRequired,
  togglePlay: PropTypes.func.isRequired,
  onSeek: PropTypes.func.isRequired,
  onSeekRelease: PropTypes.func.isRequired,
  paused: PropTypes.bool.isRequired,
  muted: PropTypes.bool.isRequired,
  progress: PropTypes.number.isRequired,
  currentTime: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,
  isRotated: PropTypes.bool,
};

export default Controls;
